import { useContext } from "react";
import { SavingsCalculatorContext } from "../context";

const MAX_SELECTION = 4;

const useVersionsData = () => {
    const [state, setState, config] = useContext(SavingsCalculatorContext);

    const getLoading = () => state.loading;

    const getVersions = () => state.versions || [];

    const getVersionById = (id) =>
        (state.versions || []).find((v) => v.id === parseInt(id, 10)) || null;

    const getSelectedIds = () => state.selectedVersionIds || [];

    const getSelectedVersions = () =>
        getSelectedIds()
            .map((id) => getVersionById(id))
            .filter(Boolean);

    const isSelected = (id) => getSelectedIds().includes(parseInt(id, 10));

    const canAddMore = () => getSelectedIds().length < MAX_SELECTION;

    // El bloque puede venir "precargado" (ficha de vehículo): sin selector.
    const isPrecharged = () => config.mode === "single";

    // Datos de la tarjeta precargada que no expone /versions/: los entrega el
    // bloque y, en la ficha de modelo, los actualiza el selector de versiones.
    const getPrechargedInfo = () => {
        const precharged = state.precharged || {};
        return {
            name: precharged.name || "",
            motor: precharged.motor || "",
            image: precharged.image || "",
        };
    };

    const addVersion = (id) => {
        const parsed = parseInt(id, 10);
        if (!parsed || isSelected(parsed) || !canAddMore()) return;
        setState((prev) => ({
            ...prev,
            selectedVersionIds: [...prev.selectedVersionIds, parsed],
        }));
    };

    const removeVersion = (id) => {
        const parsed = parseInt(id, 10);
        setState((prev) => {
            const results = { ...prev.results };
            delete results[parsed];
            return {
                ...prev,
                selectedVersionIds: prev.selectedVersionIds.filter((v) => v !== parsed),
                results,
            };
        });
    };

    return {
        MAX_SELECTION,
        getLoading,
        getVersions,
        getVersionById,
        getSelectedIds,
        getSelectedVersions,
        isSelected,
        canAddMore,
        isPrecharged,
        getPrechargedInfo,
        addVersion,
        removeVersion,
    };
};

export default useVersionsData;
